// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__hLUwo","app_title":"Header_app_title__i5v-v","nav_list":"Header_nav_list__oUjpJ","nav_item":"Header_nav_item__pWWZc"};